import { render, staticRenderFns } from "./ClienteScheda.vue?vue&type=template&id=031bfcc9"
import script from "./ClienteScheda.vue?vue&type=script&lang=js"
export * from "./ClienteScheda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports